import { useContext, useEffect } from "react";
import { ActivitiesContext } from "./context/activities-context";
import Loading from "./Loading/Loading";

const ActivitiesResults = (props) => {
	const {
		activities,
		activitiesCards,
		isLoading,
		isLoadingMore,
		isLoadingDictionary,
		startCard,
		limit,
		dictionaryWords,
	} = useContext(ActivitiesContext);

	return (
		<div className="activities__results two-thirds">
			<div className="c-fiche-wrap u-clear">
				{activitiesCards}							
			</div>
			{isLoading ? (				
				<Loading />				
			) : (
				<>						
						{activitiesCards.length > 0 && activities.totalItems > startCard + limit.current && (
							!isLoadingMore &&
								<div className="status">
								<button
									className="c-button"
									onClick={props.loadMore}
								>
									{dictionaryWords.loadMore}
								</button>
							</div>
						)}
				</>

			)}
			
			{activities.totalItems === 0 && (
				<div className="status empty">
					<p>{dictionaryWords.noResults}</p>
				</div>
			)}

			{isLoadingMore &&
				<Loading />		
			}
		</div>
	);
};

export default ActivitiesResults;
